// German dictionary — keep structurally identical to en.js.
const de = {
  nav: {
    info: 'INFO',
  },

  hero: {
    subtitle: 'Erleben Sie Badminton-Turniere in der schönen Stadt Trenčín',
    info: 'INFO',
    book: 'UNTERKUNFT BUCHEN',
  },

  home: {
    upcomingTitle: 'Kommende Veranstaltungen 2026',
    u15Card: 'SLOVAK YOUTH Badminton Europe U15 circuit',
    u17Card: 'SLOVAK YOUTH Badminton Europe U17 circuit',
    u13Card: 'SLOVAK YOUTH Badminton Europe U13 circuit',
    labelUpcoming: 'Demnächst',
    eventDateShort: '25.–27. September',
  },

  tournament: {
    entryDeadline: 'Meldeschluss:',
    upcoming: 'Demnächst',
    deadlineU17: '25. August 2026',
    deadlineU13: '11. September 2026',
    eventDate: '25.–27. September 2026',
    invitation: 'EINLADUNG',
    register: 'ANMELDUNG',
    draws: 'AUSLOSUNG',
    acceptanceList: 'TEILNEHMERLISTE',
    infoTitle: 'Turnierinformationen',
    entryFees: 'Startgebühren:',
    singles25: 'Einzel = 25 €',
    singles40: 'Einzel = 40 €',
    doubles20: 'Doppel = 20 € / Spieler',
    doubles30: 'Doppel = 30 € / Spieler',
    feesPayment: 'Die Startgebühren sind per Banküberweisung vor dem Turnier oder in bar (EUR) beim Veranstalter während des Turniers zu zahlen.',
    shuttlesLabel: 'Offizieller Turnierball:',
    shuttlesBrand: 'KAWASAKI SHUTTLECOCK TEAM 1',
    shuttlesText: 'Pro Spiel werden 2 Bälle gestellt, weitere Bälle stellen die Teilnehmer selbst. KAWASAKI SHUTTLECOCK TEAM 1 kann beim Veranstalter erworben werden.',
    managersMeeting: 'Team-Manager-Besprechung:',
    meetingU17: 'Donnerstag, 24. September 2026, 19 Uhr in der Halle.',
    mainEvent: 'Hauptfeld',
    finals: 'Finale',
    provisionalNote: 'ⓘ Die vorläufigen Zeiten können sich je nach Meldezahl ändern. Der endgültige Zeitplan (mit dem genauen geplanten Ende aller Spiele) wird spätestens 20 Tage vor Turnierbeginn auf der Website veröffentlicht.',
    seedingNote: 'Setzung und Auslosung erfolgten gemäß der BEC European U17 Rangliste vom 17. September.',
    koSystemNote: 'Die Einzel werden in der ersten Phase in Gruppen, danach im K.-o.-System gespielt; die Doppel werden im K.-o.-System gespielt. Bei Streitigkeiten ist die Entscheidung des Referees endgültig.',
    day25: '25. September',
    day26: '26. September',
    day27: '27. September',
  },

  info: {
    heroTitle: 'Informationen',
    contactsTitle: 'Kontakt & Anfahrt',
    director: 'Turnierdirektor:',
    contactPerson: 'Kontaktperson:',
    phoneNumber: 'Telefon:',
    email: 'Email:',
    venue: 'Austragungsort:',
    transportTitle: 'Transfer',
    transportIntro: 'Der Veranstalter bietet gegen Gebühr einen Transfer an von:',
    transportDetails: 'Senden Sie Ihre Reisedaten so früh wie möglich an sj.bedminton@gmail.com. Die Transfergebühren sind per Banküberweisung vor dem Turnier oder in bar (EUR) beim Veranstalter während des Turniers zu zahlen.',
    transportWalking: 'Alle offiziellen Hotels sind fußläufig zur Halle, daher gibt es keinen Transfer zwischen Halle und Hotels.',
    mealsDesc: 'Das Restaurant ist Teil der Halle. Mittag- und Abendessen werden als Buffet mit vielfältiger Auswahl serviert – all you can eat:',
    transportBa: 'Flughafen BRATISLAVA = 30 € / Person / einfache Fahrt',
    transportVie: 'Flughafen WIEN = 40 € / Person / einfache Fahrt',
    accomTitle: 'Unterkunft',
    accomOrder: 'Die Unterkunft wird direkt über unser Online-Buchungsformular gebucht.',
    accomPayment: 'Die Hotelrechnung ist per Banküberweisung vor dem Turnier oder in bar (EUR) direkt nach der Ankunft in der Sporthalle beim Veranstalter zu bezahlen. Bezahlt wird pro Zimmer, nicht pro Person.',
    breakfastIncluded: 'Frühstück inklusive',
    doubleRoom85: 'Doppelzimmer = 85 €/Nacht',
    tripleRoom100: 'Dreibettzimmer = 100 €/Nacht',
    fourRoom110: 'Vierbettzimmer = 110 €/Nacht',
    doubleRoom95: 'Doppelzimmer = 95 €/Nacht',
    tripleRoom110: 'Dreibettzimmer = 110 €/Nacht',
    singleRoom65: 'Einzelzimmer = 65 €/Nacht',
    apartment170: 'Apartment (2–4 Personen) = 170 €/Nacht',
    apartmentMinStay: 'Mindestaufenthalt = 3 Nächte. Frühstück inklusive.',
    apartmentDesc: 'Das Apartment umfasst: 2 separate Doppelzimmer, Bad, Küche, Wohnzimmer, Waschmaschine.',
    distVenue: 'Direkt am Austragungsort.',
    dist14: '1,4 km von der Halle.',
    dist19: '1,9 km von der Halle.',
    servicesTitle: 'Weitere Leistungen',
    stringing: 'Besaitung:',
    stringingAvail: 'Während des gesamten Turniers verfügbar:',
    stringingOnly: 'Besaitung = 10 €',
    stringingNew: 'Besaitung + neue Saite = 18 €',
    meals: 'Verpflegung:',
    lunch: 'Mittagessen = 12 €',
    dinner: 'Abendessen = 12 €',
  },

  booking: {
    headerTitle: 'Unterkunft buchen',
    headerSub: 'Slovak Junior & Youth · Trenčín',
    step1Title: 'Turnier auswählen',
    underAge: (age) => `Unter ${age}`,
    contactTitle: 'Kontaktdaten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phone: 'Telefon',
    email: 'Email',
    emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    selectCountry: 'Land auswählen',
    searchCountry: 'Land suchen…',
    chooseHotel: 'Hotel auswählen',
    checkingAvail: 'Verfügbarkeit wird geprüft…',
    availUnknown: 'Die Verfügbarkeit konnte nicht geprüft werden — die angezeigten Zahlen sind möglicherweise nicht aktuell.',
    unavailable: 'Ausgebucht',
    selfCatering: 'Ohne Verpflegung',
    breakfast: 'Frühstück inklusive',
    atVenue: 'Am Austragungsort · 0 km',
    fromVenue14: '1,4 km von der Halle',
    fromVenue19: '1,9 km von der Halle',
    rooms: 'Zimmer',
    perNight: '€ / Nacht',
    addRoom: 'Zimmer hinzufügen',
    soldOut: 'Ausgebucht',
    minNights3: 'Apartments erfordern einen Mindestaufenthalt von 3 Nächten.',
    noRoomsLeft: 'In diesem Hotel sind keine Zimmer mehr frei',
    onlyRoomsLeft: (n) => `Nur noch ${n} Zimmer in diesem Hotel frei`,
    roomsAvailable: (n, total) => `${n} von ${total} Zimmern frei`,
    selectedRooms: 'Ausgewählte Zimmer',
    remove: 'Entfernen',
    checkin: 'Anreise',
    checkout: 'Abreise',
    nights: (n) => `${n} ${n === 1 ? 'Nacht' : 'Nächte'}`,
    personFirst: (i) => i === 1 ? 'Vorname (Person 1)' : `Vorname (Person ${i}, optional)`,
    personLast: (i) => i === 1 ? 'Nachname (Person 1)' : `Nachname (Person ${i}, optional)`,
    addAnotherRoom: 'Weiteres Zimmer hinzufügen',
    summaryTitle: 'Zusammenfassung der Reservierung',
    tournamentLabel: 'Turnier:',
    hotelLabel: 'Hotel:',
    contactLabel: 'Kontakt:',
    phoneLabel: 'Telefon:',
    emailLabel: 'Email:',
    person: 'Person',
    estimatedTotal: 'Gesamt',
    paymentNote: 'Zahlung per Banküberweisung vor dem Turnier oder in bar (EUR) bei der Ankunft. Bezahlt wird pro Zimmer, nicht pro Person.',
    overFull: (hotel) => `${hotel} ist soeben ausgebucht — bitte gehen Sie zurück und wählen Sie ein anderes Hotel.`,
    overSome: (n, hotel, remove) => `Nur noch ${n} Zimmer im ${hotel} frei — bitte entfernen Sie ${remove} Zimmer oder wählen Sie ein anderes Hotel.`,
    btnContact: 'Kontaktdaten',
    btnHotel: 'Hotel auswählen',
    btnRoom: 'Zimmer auswählen',
    btnGuests: 'Gäste hinzufügen',
    btnReview: 'Prüfen & absenden',
    btnSubmit: 'Reservierung absenden',
    btnSubmitting: 'Wird gesendet…',
    btnBack: 'Zurück',
    btnClose: 'Schließen',
    successTitle: 'Reservierung abgeschickt!',
    successText: 'Ihre Unterkunftsanfrage ist eingegangen. Der Veranstalter bestätigt sie und sendet die Zahlungsinformationen an Ihre E-Mail.',
    confirmHotelChange: 'Beim Hotelwechsel werden die ausgewählten Zimmer entfernt. Fortfahren?',
    submitError: 'Entschuldigung, beim Senden der Reservierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    roomTypes: {
      'Single room': 'Einzelzimmer',
      'Double room': 'Doppelzimmer',
      'Triple room': 'Dreibettzimmer',
      '4-person room': 'Vierbettzimmer',
      'Apartment (2-4 persons)': 'Apartment (2–4 Personen)',
    },
  },

  reg: {
    notOpen: 'Die Anmeldung ist noch nicht geöffnet.',
    headerTitle: 'Turnieranmeldung',
    step1Title: 'Verein & Kontakt',
    club: 'Vereinsname',
    country: 'Land',
    managerTitle: 'Team-Manager',
    singlesTitle: 'Meldungen — Einzel',
    doublesTitle: 'Meldungen — Doppel',
    addSingles: 'Einzelspieler hinzufügen',
    addDoubles: 'Doppelpaar hinzufügen',
    noEntries: 'Noch keine Meldungen — dieser Schritt kann übersprungen werden.',
    player1: 'Spieler 1',
    player2opt: 'Spieler 2 (optional)',
    partnerNote: 'Eine Doppelmeldung ist auch mit einem Spieler gültig — der Partner kann später ergänzt werden.',
    discipline: 'Disziplin',
    disciplines: {
      BS: 'Jungen-Einzel',
      GS: 'Mädchen-Einzel',
      BD: 'Jungen-Doppel',
      GD: 'Mädchen-Doppel',
      XD: 'Gemischtes Doppel',
    },
    summaryTitle: 'Zusammenfassung der Anmeldung',
    clubLabel: 'Verein:',
    entriesLabel: 'Meldungen:',
    entriesCount: (n) => `${n} ${n === 1 ? 'Meldung' : 'Meldungen'}`,
    needOneEntry: 'Fügen Sie vor dem Absenden mindestens eine Meldung hinzu (Einzel oder Doppel).',
    btnSingles: 'Einzel',
    btnDoubles: 'Doppel',
    btnSubmit: 'Anmeldung absenden',
    successTitle: 'Anmeldung abgeschickt!',
    successText: 'Ihre Meldungen sind eingegangen. Der Veranstalter bestätigt die Anmeldung per E-Mail.',
  },
};

export default de;
